import type { RootState } from 'reducers';
import { baseSelect } from 'selectors/selector-utils';

// `baseSelect` walks the state path dynamically, so its selector is typed to
// return `unknown`; cast at this boundary to the known `boolean` shape of
// `ui.userIsTabbing`. The runtime selector (and its memoization) is unchanged.
export const selectUserIsTabbing = baseSelect('ui.userIsTabbing', false) as unknown as (
  state: RootState,
) => boolean;
